var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorsMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2399_5245",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2399_5245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20964 17.0833L2.08464 11.9583C1.94575 11.8194 1.84158 11.6666 1.77214 11.5C1.70269 11.3333 1.66797 11.1597 1.66797 10.9791C1.66797 10.7986 1.70269 10.625 1.77214 10.4583C1.84158 10.2916 1.94575 10.1388 2.08464 9.99996L6.8763 5.22913L4.66797 3.02079L5.95964 1.66663L14.293 9.99996C14.4319 10.1388 14.5326 10.2916 14.5951 10.4583C14.6576 10.625 14.6888 10.7986 14.6888 10.9791C14.6888 11.1597 14.6576 11.3333 14.5951 11.5C14.5326 11.6666 14.4319 11.8194 14.293 11.9583L9.16797 17.0833C9.02908 17.2222 8.8763 17.3263 8.70964 17.3958C8.54297 17.4652 8.36936 17.5 8.1888 17.5C8.00825 17.5 7.83464 17.4652 7.66797 17.3958C7.5013 17.3263 7.34852 17.2222 7.20964 17.0833ZM8.1888 6.54163L3.73047 11H12.6471L8.1888 6.54163ZM16.5013 17.5C16.0013 17.5 15.5777 17.3229 15.2305 16.9687C14.8832 16.6145 14.7096 16.1805 14.7096 15.6666C14.7096 15.2916 14.8034 14.9375 14.9909 14.6041C15.1784 14.2708 15.3902 13.9444 15.6263 13.625L16.5013 12.5L17.418 13.625C17.6402 13.9444 17.8485 14.2708 18.043 14.6041C18.2374 14.9375 18.3346 15.2916 18.3346 15.6666C18.3346 16.1805 18.1541 16.6145 17.793 16.9687C17.4319 17.3229 17.0013 17.5 16.5013 17.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorsMedium);
export default __webpack_public_path__ + "static/media/colors_medium.17902b83bd5564dcef2f5dd49e5e8c52.svg";
export { ForwardRef as ReactComponent };